import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountRepositoryService {
  constructor() {}

  getAccountObject() {
    var accountString = localStorage.getItem('account');
    if (accountString) {
      return JSON.parse(accountString);
    }
    return {
      clientKey: '',
      accountName: '',
      tabletName: '',
      apiKey: '',
      timestamp: 0,
      password: '',
      isInAdminMode: false,
      surveysInfos: [],
      foldersInfos: [],
      group: null,
      licenceType: null,
      isExitMode: false,
      exitVisitorId: null,
      agendaId: null,
    };
  }

  getDeviceInfos() {
    var infoString = localStorage.getItem('infos');
    if (infoString) {
      return JSON.parse(infoString);
    }
    return {
      deviceName: '',
      phone: '',
      address: '',
      comments: '',
    };
  }

  getDeviceParameters() {
    var parametersString = localStorage.getItem('parameters');
    if (parametersString) {
      return JSON.parse(parametersString);
    }
    return {
      restartFormTimer: 30,
      startFormTimer: 8,
      accessibilityMode: false,
      infiniteSurveyMode: false,
    };
  }

  account = this.getAccountObject();
  appVersion = environment.APP_VERSION;
  infos = this.getDeviceInfos();
  parameters = this.getDeviceParameters();
  isActivated = true;

  saveAccountObject() {
    if (this.account) {
      localStorage.setItem('account', JSON.stringify(this.account));
    }
  }

  saveName(value) {
    if (value == undefined) {
      value = '';
    }
    this.infos.deviceName = value;
    localStorage.setItem('infos', JSON.stringify(this.infos));
  }

  savePhone(value) {
    if (value == undefined) {
      value = '';
    }
    this.infos.phone = value;
    localStorage.setItem('infos', JSON.stringify(this.infos));
  }

  saveAddress(value) {
    if (value == undefined) {
      value = '';
    }
    this.infos.address = value;
    localStorage.setItem('infos', JSON.stringify(this.infos));
  }

  saveComments(value) {
    if (value == undefined) {
      value = '';
    }
    this.infos.comments = value;
    localStorage.setItem('infos', JSON.stringify(this.infos));
  }

  saveStartFormTimer(value) {
    if (value == undefined) {
      value = '';
    }
    this.parameters.startFormTimer = value;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  }

  saveRestartFormTimer(value) {
    if (value == undefined) {
      value = '';
    }
    this.parameters.restartFormTimer = value;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  }

  saveInfiniteSurveyMode(value) {
    this.parameters.infiniteSurveyMode = value;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  }

  saveAccessibilityMode(value) {
    this.parameters.accessibilityMode = value;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  }

  saveTabletInfos(name, phone, address, comments) {
    if (name == undefined) {
      name = '';
    }
    if (phone == undefined) {
      phone = '';
    }
    if (address == undefined) {
      address = '';
    }
    if (comments == undefined) {
      comments = '';
    }
    this.infos.deviceName = name;
    this.infos.phone = phone;
    this.infos.address = address;
    this.infos.comments = comments;
    localStorage.setItem('infos', JSON.stringify(this.infos));
  }

  resetParameters() {
    this.saveParameters(undefined, undefined, false, false);
  }

  saveParameters = function (
    restartFormTimer,
    startFormTimer,
    accessibilityMode,
    infiniteSurveyMode
  ) {
    if (restartFormTimer == undefined) {
      restartFormTimer = 30;
    }
    if (startFormTimer == undefined) {
      startFormTimer = 8;
    }
    this.parameters.restartFormTimer = restartFormTimer;
    this.parameters.startFormTimer = startFormTimer;
    this.parameters.accessibilityMode = accessibilityMode;
    this.parameters.infiniteSurveyMode = infiniteSurveyMode;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  };

  getIsActivated() {
    return this.isActivated;
  }

  setIsActivated = function (activated) {
    this.isActivated = activated;
  };

  getAppVersion = function () {
    return this.appVersion;
  };

  getClientKey = function () {
    return this.getAccountObject().clientKey;
  };
  setClientKey = function (key) {
    this.account.clientKey = key;
    this.saveAccountObject();
  };
  getAccountName = function () {
    return this.getAccountObject().accountName;
  };
  setAccountName = function (name) {
    this.account.accountName = name;
    this.saveAccountObject();
  };
  isLogged() {
    return this.getAccountObject().apiKey &&
      this.getAccountObject().apiKey.length !== 0
      ? true
      : false;
  }
  getApiKey = function () {
    return this.getAccountObject().apiKey;
  };
  setApiKey = function (key) {
    this.account.apiKey = key;
    this.saveAccountObject();
  };
  getTimeStamp = function () {
    return this.getAccountObject().timestamp;
  };
  setTimeStamp = function (time) {
    this.account.timestamp = time;
    this.saveAccountObject();
  };
  setPassword = function (password) {
    this.account.password = password;
    this.saveAccountObject();
  };
  setSuperPassword = function (superPassword) {
    this.account.superPassword = superPassword;
    this.saveAccountObject();
  };
  getPassword = function () {
    return this.getAccountObject().password;
  };
  getSuperPassword = function () {
    return this.getAccountObject().superPassword;
  };
  setIsInAdminMode = function (value) {
    this.account.isInAdminMode = value;
    this.saveAccountObject();
  };
  getIsInAdminMode = function () {
    return this.getAccountObject().isInAdminMode;
  };
  getGroup = function () {
    return this.getAccountObject().group;
  };
  setGroup = function (value) {
    this.account.group = value;
    this.saveAccountObject();
  };
  setSurveyInfos = function (surveys) {
    this.account.surveysInfos = surveys;
    this.saveAccountObject();
  };
  setFoldersInfos = function (folders) {
    this.account.foldersInfos = folders;
    this.saveAccountObject();
  };

  getSurveyInfos = function () {
    return this.getAccountObject().surveysInfos;
  };
  getFoldersInfos = function () {
    return this.getAccountObject().foldersInfos;
  };

  setTabletName = function (name) {
    this.account.tabletName = name;
    this.saveAccountObject();
  };
  getTabletName = function () {
    return this.getAccountObject().tabletName;
  };

  setLicenceType = function (licenceType) {
    this.account.licenceType = licenceType;
    this.saveAccountObject();
  };
  getLicenceType = function () {
    return this.getAccountObject().licenceType;
  };

  getIsExitMode = function () {
    return this.getAccountObject().isExitMode || false;
  };

  setIsExitMode = function (value) {
    this.account.isExitMode = value;
    this.saveAccountObject();
  };

  getExitVisitorId = function () {
    return this.getAccountObject().exitVisitorId || null;
  };

  setExitVisitorId = function (value) {
    this.account.exitVisitorId = value;
    this.saveAccountObject();
  };

  getAgendaId = function () {
    return this.getAccountObject().agendaId || null;
  };

  setAgendaId = function (value) {
    this.account.agendaId = value;
    this.saveAccountObject();
  };

  deleteAccount = function () {
    this.account = {
      clientKey: '',
      accountName: '',
      tabletName: '',
      apiKey: '',
      timestamp: 0,
      password: '',
      isInAdminMode: false,
      surveysInfos: [],
      isExitMode: false,
      exitVisitorId: null,
      agendaId: null,
    };
    this.saveAccountObject();
  };
}
